import yunxinIM, { normalizeLoginInfo } from './yunxinIM'

function persistLoginInfo(loginInfo = {}) {
	const normalizedLoginInfo = normalizeLoginInfo(loginInfo)
	localStorage.setItem('loginInfo', JSON.stringify(normalizedLoginInfo))
	if (normalizedLoginInfo.accessToken) {
		sessionStorage.setItem('accessToken', normalizedLoginInfo.accessToken)
	}
	if (normalizedLoginInfo.refreshToken) {
		sessionStorage.setItem('refreshToken', normalizedLoginInfo.refreshToken)
	}
	return normalizedLoginInfo
}

async function initYunxinAfterLogin(loginInfo = {}) {
	const normalizedLoginInfo = persistLoginInfo(loginInfo)
	if (!normalizedLoginInfo.imAccid || !normalizedLoginInfo.imToken) {
		console.warn('[loginHelper] 登录返回缺少 imAccid/imToken，跳过云信 SDK 初始化')
		return false
	}
	await yunxinIM.init({
		account: normalizedLoginInfo.imAccid,
		token: normalizedLoginInfo.imToken
	})
	return true
}

async function initYunxinFromSavedLoginInfo() {
	try {
		const loginInfo = JSON.parse(localStorage.getItem('loginInfo') || '{}')
		const normalizedLoginInfo = normalizeLoginInfo(loginInfo)
		if (!normalizedLoginInfo.imAccid || !normalizedLoginInfo.imToken) {
			return false
		}
		await yunxinIM.init({
			account: normalizedLoginInfo.imAccid,
			token: normalizedLoginInfo.imToken
		})
		return true
	} catch (error) {
		console.warn('[loginHelper] 从本地登录信息初始化云信失败:', error)
		return false
	}
}

export {
	initYunxinAfterLogin,
	initYunxinFromSavedLoginInfo,
	persistLoginInfo
}
